"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfOrientationOpportunityRequestDto = instanceOfOrientationOpportunityRequestDto;
exports.OrientationOpportunityRequestDtoFromJSON = OrientationOpportunityRequestDtoFromJSON;
exports.OrientationOpportunityRequestDtoFromJSONTyped = OrientationOpportunityRequestDtoFromJSONTyped;
exports.OrientationOpportunityRequestDtoToJSON = OrientationOpportunityRequestDtoToJSON;
exports.OrientationOpportunityRequestDtoToJSONTyped = OrientationOpportunityRequestDtoToJSONTyped;
/**
 * Check if a given object implements the OrientationOpportunityRequestDto interface.
 */
function instanceOfOrientationOpportunityRequestDto(value) {
    return true;
}
function OrientationOpportunityRequestDtoFromJSON(json) {
    return OrientationOpportunityRequestDtoFromJSONTyped(json, false);
}
function OrientationOpportunityRequestDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'message': json['message'] == null ? undefined : json['message'],
    };
}
function OrientationOpportunityRequestDtoToJSON(json) {
    return OrientationOpportunityRequestDtoToJSONTyped(json, false);
}
function OrientationOpportunityRequestDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'message': value['message'],
    };
}
//# sourceMappingURL=OrientationOpportunityRequestDto.js.map